import { use, useEffect, useMemo, useRef, useState, useContext } from "react";
import {
  Button,
  Checkbox,
  Link,
  TextField,
  Typography,
  InputAdornment,
  CircularProgress,
  Modal,
  Box,
} from "@mui/material";
import Spark_Logo from "../../../assets/baseVersion/Spark_Newlogo.svg";
import spark_logo_dark from "../../../assets/spark_logo_dark.svg"
import Spark_White_Logo from "../../../assets/baseVersion/Spark-white.svg";
import { ThemeContext } from "../../../ThemeContext";
import { useFormik } from "formik";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import MicroSoft_Logo from "../../../assets/MicroSoft_Logo.svg";
import { useAuth, useStorageManager } from "../../../shared/hooks";
import "./login.css";
import { toast } from "react-toastify";
import { useTokens } from "../../../shared/hooks";
import ActiveSessionModal from "../../../components/active_session";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import AppCaptcha from "../../../components/captcha";
import {
  captchaConfig,
  isOfflineCaptcha,
  SHOW_CAPTCHA_ON_FAILED_ATTEMPTS,
  SITE_KEY,
} from "../shared/captcha-constants";
import { ILoggedUser } from "./types";
import { expiredPasswordPath, passwordExpiryWarning } from "./passwordExpiry";
import { loginValidationSchema } from "./validation_schema";
import { IPermission, parseRoles } from "../shared/utils";
import axiosInstance from "../../../axios/axios";
import { END_POINTS } from "../../../shared";
import { useDispatch, useSelector } from "react-redux";
import { setUserLoginDetails } from "./Login_Details_slice";
import { setIsOnlyPremAssetUser, setIsBothCloudAndPremAssetUser, setIsOnlyCloudUser, setIsNewUserTrue } from "./Login_Details_slice";
import { ROLES_CONTENT_PROPS } from "../../../shared/constants/constant-data";
import { authActions } from "../../../store/authSlice";
import SessionTimeout from "../../../assets/SessionTimeout.svg";
import { setIdleTimeout } from "../idleTimeOut/idleTimeOut.slice";
import CloseIcon from '@mui/icons-material/Close';

const label = { inputProps: { "aria-label": "RememberMe Checkbox" } };

const Login = () => {
  const navigate = useNavigate();
  const themeContext = useContext(ThemeContext);
  const darkMode = themeContext?.darkMode;

  const { login, verifyMfaLogin, resendMfaOtp, authenticateSingleSignIn } = useAuth();
  const { setAccessTokens } = useTokens();
  const { setCookie, getCookie, deleteCookie, saveToLocalStorage, getFromLocalStorage } = useStorageManager();
  const recaptchaRef = useRef<any>(null);

  const [showPassword, setShowPassword] = useState(false);
  const [showActiveSessionModal, setShowActiveSessionModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [ssoLoading, setSsoLoading] = useState(false);
  const [failedAttempts, setFailedAttempts] = useState(0);
  const [captchaToken, setCaptchaToken] = useState("");
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [mfaRequired, setMfaRequired] = useState(false);
  const [mfaToken, setMfaToken] = useState("");
  const [mfaEmailHint, setMfaEmailHint] = useState("");
  const [mfaOtp, setMfaOtp] = useState("");
  const [mfaResendSeconds, setMfaResendSeconds] = useState(0);
  const loginDetail: ILoggedUser = JSON.parse(getCookie("userDetail") || "{}");
  const [open, setOpen] = useState(false);
  const [roleLogoutOpen, setRoleLogoutOpen] = useState(false);
  const [roleLogoutMessage, setRoleLogoutMessage] = useState("");
  const Timeout = useSelector((state: any) => state.idleTimeout.timeout);



  // const { saveToLocalStorage } = useStorageManager();

  const dispatch = useDispatch();

  const setRole = (roles: IPermission[]) => {
    const permission = parseRoles(roles);

    dispatch(
      authActions.permission({
        permission: permission,
      })
    );
  };

  const handleRememberMe = () => {
    setRememberMe(!rememberMe);
  };

  useEffect(() => {
    console.log(Timeout, "Timeout");
    const timeout = getCookie("timeout")
    //setOpen(true);
    if (timeout == "true") {
      setOpen(true);
      deleteCookie("timeout")
      //dispatch(setIdleTimeout({ timeout:false}));
    }
  }, [Timeout]);

  // Check for role logout reason (cookie approach like session timeout)
  useEffect(() => {
    const roleLogoutReason = getCookie('roleLogoutReason');
    if (roleLogoutReason) {
      const message = roleLogoutReason === 'role_updated'
        ? 'Your role has been updated. Please sign in again to continue.'
        : 'Your role has been deleted. Please sign in again to continue.';
      setRoleLogoutMessage(message);
      setRoleLogoutOpen(true);
      deleteCookie('roleLogoutReason');
    }
  }, []);

  const userDetails = async () => {
    dispatch(setIsOnlyPremAssetUser({ isOnlyPremAssetUser: false }));
    dispatch(setIsOnlyCloudUser({ isOnlyCloudUser: false }));
    dispatch(setIsBothCloudAndPremAssetUser({ isBothCloudAndPremAssetUser: false }));
    const response = await axiosInstance.get(END_POINTS.USER_DETAILS);
    if (response.status === 200) {
      const data = response?.data?.data || [];
      dispatch(authActions.subscriptionData(
        data.subscription_features
      ))
      if (data) {
        // encryptionService.setEncryptionAllowed(data?.encrypt);
        setCookie("encryptionAllowed", data?.encrypt.toString());
        saveToLocalStorage("userDetails", data);
        setCookie("is_admin", data?.is_admin ? "true" : "false");
        console.log(getFromLocalStorage("userDetails"), data, "userDetails");
        const res = await axiosInstance.get(END_POINTS.IS_NEW_USER);
        let parsed = null;
        if (res.status === 200) {
          const isNewUser = res?.data?.data || false;
          saveToLocalStorage("isNewUserDetails", isNewUser);

          parsed = res?.data?.data || false;
          if (parsed.device_count == 0 && parsed.cloud_count == 0) {
            dispatch(setIsNewUserTrue({ isNewUserTrue: true }));
            //dispatch(setIsOnlyCloudUser({ is: true }));

          }
          else if (parsed.device_count > 0 && parsed.cloud_count == 0) {
            dispatch(setIsOnlyPremAssetUser({ isOnlyPremAssetUser: true }));
          } else if (parsed.device_count == 0 && parsed.cloud_count > 0) {
            dispatch(setIsOnlyCloudUser({ isOnlyCloudUser: true }));
          } else if (parsed.device_count > 0 && parsed.cloud_count > 0) {
            dispatch(setIsBothCloudAndPremAssetUser({ isBothCloudAndPremAssetUser: true }));
          }

          navigate("/dashboard");
        }




        dispatch(setUserLoginDetails({ email: data?.organization_email, firstname: data?.firstname, lastname: data?.lastname, organization: data?.organization_name, role: data?.role_name, organization_id: data?.organization_id, unique_devices: data?.subscription_features?.unique_devices, sso_enabled: data?.sso_enabled || false, global_filter: data?.global_filter }));


      }
    }
  }

  const formik = useFormik({
    initialValues: {
      username: loginDetail?.userName || "",
      password: "",
      recaptcha: "",
      offlineCaptcha: "",
    },
    validationSchema: loginValidationSchema,
    onSubmit: async () => {
      handleLogin();
    },
  });

  const resetCaptcha = () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
    setCaptchaToken("");
    setIsCaptchaValid(false);
    formik.setFieldValue("recaptcha", "");
    formik.setFieldValue("offlineCaptcha", "");
  };

  const handleCaptchaChange = (token: any) => {
    setCaptchaToken(token);
    formik.setFieldValue("recaptcha", token);
  };

  const handleOfflineCaptchaChange = (isValid: boolean) => {
    setIsCaptchaValid(isValid);
    formik.setFieldValue("offlineCaptcha", isValid ? "valid" : "");
  };

  const shouldShowCaptcha = useMemo(() => {
    return failedAttempts >= SHOW_CAPTCHA_ON_FAILED_ATTEMPTS;
  }, [failedAttempts]);

  const isCaptchaRequired = () => {
    if (shouldShowCaptcha) {
      if (!isOfflineCaptcha) {
        return !isCaptchaValid;
      } else {
        return !captchaToken;
      }
    }
    return false;
  };

  useEffect(() => {
    if (mfaResendSeconds <= 0) return;
    const timer = setTimeout(() => setMfaResendSeconds((s) => s - 1), 1000);
    return () => clearTimeout(timer);
  }, [mfaResendSeconds]);

  const completeLoginSuccess = async (response: any) => {
    const userDetail: ILoggedUser = {};
    setAccessTokens({
      access_token: response.data.access_token,
      expires_in: response.data.expires_in,
      refresh_token: response.data.refresh_token,
      user_id: "",
    });

    if (response.data.permissions?.permissions?.length > 0) {
      saveToLocalStorage(
        "roles",
        parseRoles(response.data.permissions?.permissions)
      );
    }

    if (response.status === 200) {
      userDetail.userName = formik.values.username;
      if (rememberMe) {
        userDetail.rememberMe = rememberMe;
      }
      setCookie("userDetail", JSON.stringify(userDetail));
      await userDetails();
      const expiryWarning = passwordExpiryWarning(response.data);
      if (expiryWarning) toast.warning(expiryWarning);
      setRole(response.data.permissions?.permissions);
    }
  };

  const resetMfaState = () => {
    setMfaRequired(false);
    setMfaToken("");
    setMfaEmailHint("");
    setMfaOtp("");
    setMfaResendSeconds(0);
  };

  const handleLogin = async (newSession = false) => {
    if (shouldShowCaptcha && isCaptchaRequired()) {
      toast.error("Please complete the captcha verification");
      return;
    }
    setLoading(true);
    try {
      const loginData = {
        username: formik.values.username,
        password: formik.values.password,
      };
      const response: any = await login(loginData, newSession);
      if (response?.data?.mfa_required) {
        setMfaRequired(true);
        setMfaToken(response.data.mfa_token);
        setMfaEmailHint(response.data.email_hint || formik.values.username);
        setMfaOtp("");
        setMfaResendSeconds(60);
        toast.success(response.message || "Verification code sent to your email");
        return;
      }
      if (response?.data.active_session) {
        setShowActiveSessionModal(true);
      } else {
        await completeLoginSuccess(response);
      }
    } catch (err: any) {
      const changePasswordPath = expiredPasswordPath(err);
      if (changePasswordPath) {
        navigate(changePasswordPath, { state: { passwordExpired: true } });
        return;
      }
      toast.error(err.message);
      setFailedAttempts((prevAttempts) => prevAttempts + 1);
      resetCaptcha();
    } finally {
      setLoading(false);
    }
  };

  const handleMfaVerify = async () => {
    if (!/^\d{6}$/.test(mfaOtp.trim())) {
      toast.error("Enter the 6-digit verification code");
      return;
    }
    setLoading(true);
    try {
      const payload: any = await verifyMfaLogin(mfaToken, mfaOtp.trim());
      if (payload?.data?.active_session) {
        resetMfaState();
        setShowActiveSessionModal(true);
        return;
      }
      resetMfaState();
      await completeLoginSuccess(payload);
    } catch (err: any) {
      toast.error(err.response?.data?.message || err.message || "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  const handleMfaResend = async () => {
    if (mfaResendSeconds > 0 || !mfaToken) return;
    setLoading(true);
    try {
      const response: any = await resendMfaOtp(mfaToken);
      if (response?.data?.mfa_token) {
        setMfaToken(response.data.mfa_token);
      }
      setMfaResendSeconds(60);
      toast.success(response?.message || "A new code has been sent");
    } catch (err: any) {
      const retryAfter = err.response?.data?.data?.retry_after;
      if (retryAfter) setMfaResendSeconds(Number(retryAfter));
      toast.error(err.response?.data?.message || err.message || "Unable to resend code");
    } finally {
      setLoading(false);
    }
  };

  const handleSingleSignIn = () => {
    setSsoLoading(true);
    authenticateSingleSignIn()
      .then((res: any) => {
        if (res.status === 200 && res.data) {
          const ssoUrl = res.data.url;
          window.open(ssoUrl, "_self");
        }
      })
      .catch((err: any) => {
        toast.error(err.message);
      })
      .finally(() => {
        setSsoLoading(false);
      });
  };

  const handleOnContinue = () => {
    formik.resetForm();
    setShowActiveSessionModal(false);
    resetCaptcha();
    resetMfaState();
  };

  const isButtonDisabled = useMemo(() => {
    const basicValidation =
      !formik.isValid || !formik.dirty || loading || ssoLoading;
    if (shouldShowCaptcha) {
      if (!isOfflineCaptcha) {
        return basicValidation || !isCaptchaValid;
      } else {
        return basicValidation || !captchaToken;
      }
    }

    return basicValidation;
  }, [
    formik.isValid,
    formik.dirty,
    loading,
    shouldShowCaptcha,
    isCaptchaValid,
    captchaToken,
    ssoLoading,
  ]);

  const restrictAccess = useMemo(
    () => loading || ssoLoading,
    [loading, ssoLoading]
  );

  return (
    <>
      <div className="login-container">
        <div className="login_logo">
          <img src={darkMode ? spark_logo_dark : Spark_Logo} alt="Login Logo" />
        </div>
        <h5 className="mb_2 font_bold mt_0" style={{ color: darkMode ? 'gray' : 'inherit' }}>
          {mfaRequired ? "Verify your identity" : "Sign In"}
        </h5>
        <p className="mb_5 login-subtitle">
          {mfaRequired
            ? `Enter the 6-digit code sent to ${mfaEmailHint}`
            : "Enter your details to Sign In and explore more "}
        </p>
        {mfaRequired ? (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleMfaVerify();
            }}
            autoComplete="off"
            spellCheck={false}
          >
            <TextField
              id="mfaOtp"
              label="Verification code"
              variant="outlined"
              required
              fullWidth
              name="mfaOtp"
              value={mfaOtp}
              onChange={(e) =>
                setMfaOtp(e.target.value.replace(/\D/g, "").slice(0, 6))
              }
              className="mb_3"
              inputProps={{
                inputMode: "numeric",
                autoComplete: "one-time-code",
                maxLength: 6,
              }}
            />
            <Button
              fullWidth
              variant="contained"
              type="submit"
              disabled={loading || mfaOtp.length !== 6}
              className="mb_3"
            >
              {loading ? <CircularProgress size={22} color="inherit" /> : "Verify"}
            </Button>
            <Button
              fullWidth
              variant="text"
              disabled={loading || mfaResendSeconds > 0}
              onClick={handleMfaResend}
              className="mb_2"
            >
              {mfaResendSeconds > 0
                ? `Resend code in ${mfaResendSeconds}s`
                : "Resend code"}
            </Button>
            <Button
              fullWidth
              variant="text"
              disabled={loading}
              onClick={() => {
                resetMfaState();
                formik.setFieldValue("password", "");
              }}
            >
              Back to sign in
            </Button>
          </form>
        ) : (
        <form onSubmit={formik.handleSubmit} autoComplete="off" spellCheck={false}>
          <TextField
            id="username"
            label="Email"
            variant="outlined"
            required
            fullWidth
            name="username"
            autoComplete="off"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.username}
            error={formik.touched.username && Boolean(formik.errors.username)}
            helperText={formik.touched.username && formik.errors.username}
            className="mb_3"
            inputProps={{
              autoComplete: "off",
              autoCorrect: "off",
              autoCapitalize: "none",
              "data-lpignore": "true",
              "data-1p-ignore": "true",
            }}
          />
          <TextField
            id="password"
            label="Password"
            variant="outlined"
            fullWidth
            required
            type={showPassword ? "text" : "password"}
            name="password"
            autoComplete="new-password"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.password}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <span className="visibility-icon">
                      {showPassword ? (
                        <Visibility
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      ) : (
                        <VisibilityOff
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      )}
                    </span>
                  </InputAdornment>
                ),
              },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                ...(!showPassword && { font: "initial" }),
              },
            }}
            className="mb_3"
            inputProps={{
              autoComplete: "new-password",
              autoCorrect: "off",
              autoCapitalize: "none",
              "data-lpignore": "true",
              "data-1p-ignore": "true",
            }}
          />

          {/* Conditional CAPTCHA rendering */}
          {shouldShowCaptcha && isOfflineCaptcha && (
            <div className="mb_3">
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={SITE_KEY}
                onChange={handleCaptchaChange}
              />
              {/* {formik.touched.recaptcha && formik.errors.recaptcha && (
              <Typography color="error" variant="caption">
                {formik.errors.recaptcha}
              </Typography>
            )} */}
            </div>
          )}

          {/* Custom offline CAPTCHA */}
          {shouldShowCaptcha && !isOfflineCaptcha && (
            <div className="mb_3">
              <AppCaptcha
                config={captchaConfig}
                onCaptchaStatus={handleOfflineCaptchaChange}
              />
              {/* {formik.touched.offlineCaptcha && formik.errors.offlineCaptcha && (
              <Typography color="error" variant="caption">
                {formik.errors.offlineCaptcha}
              </Typography>
            )} */}
            </div>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
            className="mb_3"
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
              className="text-muted"
            >
              <Checkbox
                {...label}
                size="small"
                className="remember_checkbox"
                onChange={handleRememberMe}
              />
              <Typography className="remember_link">Remember me</Typography>
            </div>
            <Link
              href="/forgot-password"
              underline="none"
              className="forgot_link"
            >
              Forgot Password?
            </Link>
          </div>

          <Button
            fullWidth
            variant="contained"
            color="primary"
            disabled={isButtonDisabled}
            className={`btn btn-primary`}
            endIcon={
              loading ? <CircularProgress size={15} color="inherit" /> : null
            }
            type="submit"
          >
            Sign In
          </Button>
        </form>
        )}

        {!mfaRequired && (
        <>
        <div className="text_center text-muted not-a-mem">
          Not a member yet?
          <Link href="/register" className="forgot_link singUp-link">
            Sign Up
          </Link>
          <p className="or-text">Or</p>
        </div>

        <Button
          variant="outlined"
          fullWidth
          className="btn-plain microsoft-btn"
          onClick={handleSingleSignIn}
          endIcon={
            ssoLoading ? <CircularProgress size={15} color="inherit" /> : null
          }
        >
          <img src={MicroSoft_Logo} alt="Microsoft Logo" />
          <span>Sign In with Microsoft</span>
        </Button>
        </>
        )}

        {showActiveSessionModal && (
          <ActiveSessionModal
            open={showActiveSessionModal}
            onContinue={handleOnContinue}
            onSignInAgain={() => {
              setShowActiveSessionModal(false);
              handleLogin(true);
            }}
          />
        )}
      </div>
      <Modal
        open={open}
        onClose={() => { }}
        sx={{
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
          }
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
            p: 4,
            borderRadius: 2,
            border: "none",
            outline: "none",
            zIndex: 9999,
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div>
              {/* <CloseIcon
                onClick={() => setOpen(false)}
                style={{ position: "absolute", right: 10, top: 10, cursor: "pointer" }}
              /> */}
            </div>
            <img src={SessionTimeout} alt="" style={{ marginBottom: 10 }} />
            <Typography variant="h6" gutterBottom sx={{ color: "#FD6165", fontWeight: "700", fontSize: "16px", lineHeight: "18.75px" }}>
              Session Timeout
            </Typography>
            <Typography variant="body2" gutterBottom sx={{ fontWeight: "400", fontSize: "13px", lineHeight: "18px", color: "#666666" }}>
              Your session has been timed out. Sign in again to
            </Typography>
            <Typography variant="body2" gutterBottom sx={{ fontWeight: "400", fontSize: "13px", lineHeight: "18px", color: "#666666", mb: 2 }}>
              Proceed with the system.
            </Typography>
            <Button
              variant="contained"
              onClick={() => setOpen(false)}
              sx={{
                width: "132px",
                height: "42px",
                borderRadius: "4px",
                lineHeight: "18px",
                fontSize: "13px",
                color: "#fff",               // default text color
                backgroundColor: "#FD6165",  // force background for contained
                border: "1px solid #FD6165", // optional border

                '&:hover': {
                  color: "#fff",             // text stays white
                  backgroundColor: "#e05559", // slightly darker shade on hover
                  borderColor: "#FD6165",
                },
              }}
            >
              Close
            </Button>


          </div>
        </Box>
      </Modal>

      {/* Role Logout Modal */}
      <Modal
        open={roleLogoutOpen}
        onClose={() => { }}
        sx={{
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
          }
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
            p: 4,
            borderRadius: 2,
            border: "none",
            outline: "none",
            zIndex: 9999,
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <img src={SessionTimeout} alt="" style={{ marginBottom: 10 }} />
            <Typography variant="h6" gutterBottom sx={{ color: "#FD6165", fontWeight: "700", fontSize: "16px", lineHeight: "18.75px" }}>
              Role Updated
            </Typography>
            <Typography variant="body2" gutterBottom sx={{ fontWeight: "400", fontSize: "13px", lineHeight: "18px", color: "#666666", textAlign: "center", mb: 2 }}>
              {roleLogoutMessage}
            </Typography>
            <Button
              variant="contained"
              onClick={() => setRoleLogoutOpen(false)}
              sx={{
                width: "132px",
                height: "42px",
                borderRadius: "4px",
                lineHeight: "18px",
                fontSize: "13px",
                color: "#fff",
                backgroundColor: "#FD6165",
                border: "1px solid #FD6165",
                '&:hover': {
                  color: "#fff",
                  backgroundColor: "#e05559",
                  borderColor: "#FD6165",
                },
              }}
            >
              Close
            </Button>
          </div>
        </Box>
      </Modal>
    </>

  );
};

export default Login;